import React from "react";
import "../css/index.scss";
import UtilityFunctions from "../util/utilityFunctions";

export default class Page extends React.Component {
  // Expose session to all pages
  static async getInitialProps({ req, res }) {
    let width = 400;

    if (req && req.logInfo) {
      width = UtilityFunctions.getDeviceWidth(req.logInfo.deviceInfo);
    } else if (window) {
      width = window.innerWidth;
    }

    let subdomain = req.tenant.subdomain;
    if (!subdomain || subdomain === "wwwdev") {
      subdomain = "www";
    }

    const canonicalUrl = `${req.protocol}://${req.get("host")}${req.path}`;

    const tenantConfig = req.tenant.config.commonConfig;

    const tenantSignupConfig = req.tenant.config.signupConfig;

    let _csrf = "";
    if (res && res.locals) {
      _csrf = res.locals._csrf;
    }

    let session = null;
    if (req) {
      session = req.sessionInfo;
    }

    const store = {
      width,
      subdomain,
      session,
      canonicalUrl,
      tenantConfig,
      tenantSignupConfig,
      _csrf
    };

    return {
      session,
      store
    };
  }
}
